<div class="wrap">

    <h1>How to contact us?</h1>
    <div class="contact">
        <p>Chaussée d’Antoing, 55,</p>
        <p> B-7500 Tournai (Be)</p>

        <p> Tél. : +32 (0)69 66 95 10</p>
        <p>Fax : +32 (0)69 66 95 45</p>
    </div>
</div>